// extracted by mini-css-extract-plugin
export default {"title":"_9651882942","bld":"_977e465739"};